import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import 'bootstrap/dist/css/bootstrap.min.css';
// import './styles/global.css';
// import './styles/auth.css';
// import './styles/card.css';
import './styles/fonts.css';
import './styles/mobile-style.css';
// import './styles/Footer.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
